module.exports = __webpack_public_path__ + "media/Images/PlantKeyMan-83879283.svg";